<template>
  <b-row>
    <b-col md="12" class="mb-3">

      <h4 class="chr-title">{{result.name}}
        <sup class="text-warning">
          <span v-for="star in result.stars" :key="star">
            <b-icon icon="suit-heart-fill" class="text-danger" />
          </span>
        </sup>
      </h4>

      <h5 class="package-title my-2 font-weight-bold" v-translate>Price details</h5>
      <b-table-simple responsive small>
          <b-thead>
            <b-tr>
              <b-th v-translate>Total client</b-th>
              <b-th v-translate>Taxes</b-th>
              <b-th v-translate> Commision</b-th>
              <b-th v-translate>Total payment</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>{{ meal.price + meal.tax + serviceTax  }}</b-td>
              <b-td>{{ meal.tax + serviceTax }}</b-td>
              <b-td>{{ meal.commission + serviceTax }}</b-td>
              <b-td>{{ meal.price + meal.tax - meal.commission }}</b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="4" class="text-center"> <a href="https://christiantourro.sharepoint.com/sites/InfoCHR/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FInfoCHR%2FShared%20Documents%2FParteneri%2F6%2E%20Conditii%20de%20plata%2FConditii%20de%20plata%202023%2D2024%2Epdf&parent=%2Fsites%2FInfoCHR%2FShared%20Documents%2FParteneri%2F6%2E%20Conditii%20de%20plata&p=true&ga=1" target="_blank" v-translate>Verifica aici conditiile de plata</a></b-td>
            </b-tr>
          </b-tbody>
      </b-table-simple>
      <hr>
      <h5 class="package-title my-2 font-weight-bold" v-translate>Discounts applied</h5>
      <b-card class="border-0" no-body>
        <b-row v-for="(discount, packDiscount) in discounts" :key="packDiscount">
          <b-col sm="12"><h6 class="package-title">{{discount.label}}</h6></b-col>
          <b-col sm="6">
            <p v-if="discount.bookingFrom || discount.bookingTo"><b v-translate>Offer validity: </b>
              <span v-if="!discount.bookingFrom && !discount.bookingTo"><translate>any</translate></span>
              <span v-if="discount.bookingFrom && !discount.bookingTo"> <translate>from</translate> {{ discount.bookingFrom}}</span>
              <span v-if="!discount.bookingFrom && discount.bookingTo"> <translate>until</translate> {{ discount.bookingTo }}</span>
              <span v-if="discount.bookingFrom && discount.bookingTo"> <translate>between</translate> {{ discount.bookingFrom }} <translate>and</translate> {{ discount.bookingTo }}</span>
            </p>
          </b-col>
          <b-col sm="6">
            <p><b v-translate>Travel dates: </b>
              <span v-if="!discount.travelFrom && !discount.travelTo"><translate>any</translate></span>
              <span v-if="discount.travelFrom && !discount.travelTo"> <translate>from</translate> {{ discount.travelFrom}}</span>
              <span v-if="!discount.travelFrom && discount.travelTo"> <translate>until</translate> {{ discount.travelTo }}</span>
              <span v-if="discount.travelFrom && discount.travelTo"> <translate>between</translate> {{ discount.travelFrom }} <translate>and</translate>  {{ discount.travelTo }}</span>
            </p>
          </b-col>
        </b-row>
        <p class="m-0" v-if="discounts.length == 0" v-translate>No discounts were applied</p>
      </b-card>
      <b-card class="bg-light d-none" no-body v-if="paymentSchedule && paymentSchedule.length">
        <b-card-header>
          <b v-translate>Payments schedule</b>
        </b-card-header>
        <b-list-group flush>
          <b-list-group-item v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
            {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PriceDetails',
  props: {
    title: String,
    result: {
      type: Object,
      required: true
    },
    meal: {
      type: Object,
      required: true
    },
    discounts: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    serviceTax: {
      type: Number,
      required: false,
      default: 0
    },
    paymentSchedule: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  methods: {
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    }
  }
}
</script>
